import { decodeJWT } from './jwt';
import { storage } from './localStorage';

/**
 * Client admin (ROLE_CLIENT_ADMIN) — may manage statistics in the client.
 * Full admins are client admins implicitly.
 */
export const isClientAdmin = (): boolean => {
    const token = storage.getItem('token');
    if (!token) return false;
    const decoded = decodeJWT(token);
    return decoded?.user?.clientAdmin === true || decoded?.user?.admin === true;
};

/**
 * May give the company's consent to the terms and conditions: its own client
 * admin only. A full admin works in customers' tenants, so never on their behalf.
 */
export const mayAcceptTerms = (): boolean => {
    const token = storage.getItem('token');
    if (!token) return false;
    const decoded = decodeJWT(token);
    return decoded?.user?.clientAdmin === true && decoded?.user?.admin !== true;
};
